module.exports = __webpack_public_path__ + "static/media/pm25.56414017.svg";